skrilla.controller('createManualTransactionCtrl', function ($scope, searchService, srefService, currencyService) {

    $scope.newManualTrans = {
        isDeposit: false,
        isReconciliation: false
    };

    $scope.save = function(){
        searchService.get('accounts/' + $scope.newManualTrans.creditId).then(function(response) {
            const request = {...$scope.newManualTrans, amount: currencyService.multiply($scope.newManualTrans.amount, response.data.currency)};
            searchService.post("manualTransactions", request, "Manual Transaction Successfully Created!").then(function(response){
                srefService.go("manualTransactions", null);
            });
        });
    }

});
